import { getGAIdAsync } from './StoreConfigManager.js';

const missedVirtualPagePaths = [];
const missedEvents = [];
let storeName = '';

export function setStoreName(name) {
    storeName = name;
}

export function sendMissedAnalyticsOnGALoaded(id) {
    missedVirtualPagePaths.forEach(element => {
        console.log('sending missed virtual page paths', element);
        window.gtag('config', id, { 'page_path': element });
    });

    missedEvents.forEach(element => {
        console.log('sending missed events', element);
        const category = element['event_category'];
        const action = element['event_action'];
        const label = element['event_label'];
        window.gtag('event', 'play', {
            'event_category': category,
            'event_action': action,
            'event_label': label
        });
    });
}

const AtLeastOnce = {
    EventCategory: 'At least once',
    Props: {
        MovedOnce: {
            EventAction: 'Moved once',
            EventLabel: 'Moved once',
            called: false
        },
        ProductHotspotOnce: {
            EventAction: 'Product hotspot once',
            EventLabel: 'Product hotspot once',
            called: false
        },
        BuyNowOnce: {
            EventAction: 'Buy now once',
            EventLabel: 'Buy now once',
            called: false
        },
        InteractedOnce: {
            EventAction: 'Interacted once',
            EventLabel: 'Interacted once',
            called: false
        }
    }
}

const Navigation = {
    EventCategory: 'Navigation',
    Props: {
        SceneLoaded: {
            EventAction: 'Scene loaded',
            EventLabel: ''
        },
        ArrowClicked: {
            EventAction: 'Arrow clicked',
            EventLabel: ''
        },
        NavigationMenuClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: 'Navigation menu'
        },
        NavigationMenuOptionClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: '<scene name>'
        },
        WomanClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: 'Woman'
        },
        ManClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: 'Man'
        },
        KidsClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: 'Kids'
        },
        SubCatClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: '<Parent Route> - <Target Route>'
        }
    }
}

const Product = {
    EventCategory: 'Product',
    Props: {
        ProductHotspotClicked: {
            EventAction: 'Product hotspot clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        BuyNowClicked: {
            EventAction: 'PDP clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        AddedProductToFavorite: {
            EventAction: 'Favorite added',
            EventLabel: '<Product name> - <SKU>'
        },
        RemovedProductFromFavorite: {
            EventAction: 'Favorite removed',
            EventLabel: '<Product name> - <SKU>'
        },
        SpinActivated: {
            EventAction: 'Spin Activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorActivated: {
            EventAction: 'Color selector activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorOptionClicked: {
            EventAction: 'Color selector option clicked',
            EventLabel: '<Product name> - <Product color>'
        },
        AddToWishlistClicked: {
            EventAction: 'Add to wishlist clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        DetailsClicked: {
            EventAction: 'Details clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        ThumbnailClicked: {
            EventAction: 'Thumbnail clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        VideoIconClicked: {
            EventAction: 'Video icon clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        ProductImageClicked: {
            EventAction: 'Product arrow clicked',
            EventLabel: '<Product name>'
        },
        WishlistIconClicked: {
            EventAction: 'Wishlist icon clicked',
            EventLabel: 'Wishlist icon'
        },
        ProductRemoveFromWishlist: {
            EventAction: 'Product removed from wishlist',
            EventLabel: '<product name> - <sku>'
        },
    }
}

const Other = {
    EventCategory: 'Other',
    Props: {
        LogoClicked: {
            EventAction: 'Logo clicked',
            EventLabel: 'Logo clicked'
        },
        WelcomePopupButtonClicked: {
            EventAction: 'Pop-up message - [name] button clicked',
            EventLabel: 'Welcome message'
        },
        MusicButton: {
            EventAction: 'Music button',
            EventLabel: 'on / off'
        },
        FacebookButton: {
            EventAction: 'Facebook button',
            EventLabel: 'Facebook button'
        },
        TwitterButton: {
            EventAction: 'Twitter button',
            EventLabel: 'Twitter button'
        },
        WhatsAppButton: {
            EventAction: 'WhatsApp button',
            EventLabel: 'WhatsApp button'
        },
        ObsessLogo: {
            EventAction: 'Obsess logo',
            EventLabel: 'Obsess logo'
        },
        BrandLogo: {
            EventAction: 'Brand logo',
            EventLabel: 'Brand logo'
        },
        Email: {
            EventAction: 'Email',
            EventLabel: 'Entered / skipped'
        },
        StoreSelectorIcon: {
            EventAction: 'Store selector icon clicked',
            EventLabel: ''
        },
        StoreSelectorOption: {
            EventAction: 'Store selector option clicked',
            EventLabel: '<store name>'
        },
        ShareButtonClicked: {
            EventAction: 'Share icon clicked',
            EventLabel: 'Share icon'
        },
        ShareOptionClicked: { // social icon click
            EventAction: 'Share option clicked',
            EventLabel: '[Name] icon clicked'
        },
        ChatIconClicked: {
            EventAction: 'Chat icon clicked',
            EventLabel: 'Chat icon clicked'
        },
        MapSectionClicked: {
            EventAction: 'Map section clicked',
            EventLabel: 'Map section clicked - '
        },
        WishlistBookAppointmentClicked: {
            EventAction: 'Wishlist Book an appointment button clicked',
            EventLabel: 'Wishlist Book an appointment button clicked - '
        },
        WelcomePopupXButtonClicked: {
            EventAction: 'Pop-up message - X button clicked',
            EventLabel: 'Welcome message'
        },
        WelcomeCloseAwayClicked: {
            EventAction: 'Pop-up message - Closed',
            EventLabel: 'Welcome message'
        },
        WelcomeAutoCloseClicked: {
            EventAction: 'Pop-up message - Auto closed',
            EventLabel: 'Welcome message'
        },
        PoweredByClicked: {
            EventAction: 'Powered by Obsess clicked',
            EventLabel: 'Powered by Obsess'
        },
        MailIconClicked: {
            EventAction: 'Mail icon clicked',
            EventLabel: 'Mail icon'
        },
        InstagramClicked: {
            EventAction: 'Instagram link clicked',
            EventLabel: 'Instagram link'
        }
    }
}

const Content = {
    EventCategory: 'Content',
    Props: {
        InSceneVideoClicked: {
            EventAction: 'In-scene video',
            EventLabel: '<video name>'
        },
        PopupVideoClicked: {
            EventAction: 'Pop-up video',
            EventLabel: '<video name>'
        },
        ImageClicked: {
            EventAction: 'Image hotspot clicked',
            EventLabel: '<image name>'
        },
        TextClicked: {
            EventAction: 'Text',
            EventLabel: ''
        },
        LinkClicked: {
            EventAction: 'Link hotspot clicked',
            EventLabel: '<target url>'
        },
        TextPopUpHotSpotClicked: {
            EventAction: 'Text hotspot clicked',
            EventLabel: '<store name> - <view name>'
        },
        TextPopUpButtonClicked: {
            EventAction: 'Text pop-up button clicked',
            EventLabel: '<store name> - <view name>'
        },
        ImageCarouselClicked: {
            EventAction: 'Image carousel clicked',
            EventLabel: 'Image carousel clicked'
        },
        BookAppointmentClicked: {
            EventAction: 'Book an appointment hotspot clicked',
            EventLabel: 'Book an appointment hotspot clicked - ',
        }
    }
}

const Wishlist = {
    EventCategory: 'Wishlist',
    Props: {
        SMSButtonClicked: {
            EventAction: 'SMS button clicked',
            EventLabel: 'SMS button clicked'
        },
        LocalStoreIconClicked: {
            EventAction: 'Local store link clicked',
            EventLabel: '<store name> - <Local Store link>'
        },
        CallToOrderClicked: {
            EventAction: 'Call to Order Clicked',
            EventLabel: 'Call to Order'
        },
        NameAddedInOrderForm: {
            EventAction: 'Name Added in Order Form',
            EventLabel: 'Name Added in Order Form'
        },
        EmailAddedInOrderForm: {
            EventAction: 'Email Added in Order Form',
            EventLabel: 'Email Added in Order Form'
        },
        PhoneNumberAddedInOrderForm: {
            EventAction: 'Phone Number Added in Order Form',
            EventLabel: 'Phone Number Added in Order Form'
        },
        SubmitOrderClicked: {
            EventAction: 'Submit Order Clicked',
            EventLabel: 'Submit Order Clicked'
        },
        CloseOrderFormClicked: {
            EventAction: 'Close Order Form Clicked',
            EventLabel: 'Close Order Form Clicked'
        },
    }
}
function sendUserAction(eventCategory, eventAction, eventLable) {


    // TODO: track FB pixel
    let event = ''
    if (eventCategory == 'Navigation') {
        event = 'PageView'
    } else if (eventCategory == 'Product' || eventCategory == 'Content') {
        event = 'ViewContent'
    } else {
        event = 'ViewCategory'
    }
    console.log(event, {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': storeName + ' - ' + eventLable
    });
    window.fbq('track', event, {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': storeName + ' - ' + eventLable
    });

    const missedEvent = {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': storeName + ' - ' + eventLable
    };

    if (eventAction === 'Scene loaded') {
        missedEvent['non_interaction'] = true;
    }

    // TODO: track GA tag
    if (!window.gtag) {
        console.log('no gtag');
        missedEvents.push(missedEvent)
        return;
    }
    window.gtag('event', 'play', missedEvent);

    // var analytics = window.analytics;
    // analytics.track(eventAction, {
    //     'category': eventCategory,
    //     'action': eventAction,
    //     'label': storeName + ' ' + eventLable
    // });
}

// At Least Once
export function MovedOnce() {
    let prop = AtLeastOnce.Props.MovedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ProductHotspotOnce() {
    let prop = AtLeastOnce.Props.ProductHotspotOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BuyNowOnce() {
    let prop = AtLeastOnce.Props.BuyNowOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function InteractedOnce() {
    let prop = AtLeastOnce.Props.InteractedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

// Navigation
export function NavigationMenuClicked() {
    let prop = Navigation.Props.NavigationMenuClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel);
}

export function NavigationMenuOptionClicked(sceneName, tabName) {
    let prop = Navigation.Props.NavigationMenuOptionClicked;
    const eventLabel = tabName ? `${tabName} - ${sceneName}` : sceneName;
    sendUserAction(Navigation.EventCategory, prop.EventAction, eventLabel);
}

export function WomanClicked() {
    let prop = Navigation.Props.WomanClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ManClicked() {
    let prop = Navigation.Props.ManClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel);
}

export function KidsClicked() {
    let prop = Navigation.Props.KidsClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel);
}

export function SubCatClicked(parent, target) {
    let prop = Navigation.Props.SubCatClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, `${parent} - ${target}`);
}

export function SceneLoaded(sceneId) {
    console.log('sceneloaded', sceneId);
    let prop = Navigation.Props.SceneLoaded;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + sceneId);
}

export function ArrowClicked(destinationSceneId) {
    let prop = Navigation.Props.ArrowClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + destinationSceneId);
}

// Product
export function ProductHotspotClicked(sku, productName) {
    console.log('Product hotspot clicked:', productName, sku);
    let prop = Product.Props.ProductHotspotClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function BuyNowClicked(sku, productName) {
    let prop = Product.Props.BuyNowClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function SpinActivated(sku, productName) {
    console.log('Spin Activated:', productName, sku);
    let prop = Product.Props.SpinActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function ColorSelectorActivated(sku, productName) {
    let prop = Product.Props.ColorSelectorActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`)
}

export function ColorSelectorOptionClicked(productColor, productName) {
    let prop = Product.Props.ColorSelectorOptionClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${productColor}`)
}

export function AddedHeartItem(sku, productName) {
    let prop = Product.Props.AddedProductToFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function RemovedHeartItem(sku, productName) {
    let prop = Product.Props.RemovedProductFromFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function AddToWishlistClicked(eventAction, eventLabel, sku) {
    let prop = Product.Props.AddToWishlistClicked;
    sendUserAction(Product.EventCategory, eventAction, `${eventLabel} - ${sku}`);
}

export function DetailsClicked(sku, productName) {
    let prop = Product.Props.DetailsClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function ThumbnailClicked(productName) {
    let prop = Product.Props.ThumbnailClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName}`);
}

export function ProductImageClicked(productName) {
    let prop = Product.Props.ProductImageClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName}`);
}

export function VideoIconClicked(sku, productName) {
    let prop = Product.Props.VideoIconClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function WishlistIconClicked(currentScene) {
    let prop = Product.Props.WishlistIconClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, prop.EventLabel);
}


export function ProductRemoveFromWishlist(productName, sku) {
    let prop = Product.Props.ProductRemoveFromWishlist;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

// Other
export function LogoClicked() {
    let prop = Other.Props.LogoClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WelcomePopupButtonClicked(buttonLabel) {
    let prop = Other.Props.WelcomePopupButtonClicked;
    sendUserAction(Other.EventCategory, `Pop-up message - ${buttonLabel} button clicked`, prop.EventLabel);
}

export function MusicButton(isOn) {
    let eventLabel = isOn ? 'on' : 'off';
    let prop = Other.Props.MusicButton;
    sendUserAction(Other.EventCategory, prop.EventAction, eventLabel);
}

export function FacebookButtonAnalytics() {
    let prop = Other.Props.FacebookButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TwitterButtonAnalytics() {
    let prop = Other.Props.TwitterButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WhatsAppButtonAnalytics() {
    let prop = Other.Props.WhatsAppButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ObsessLogo() {
    let prop = Other.Props.ObsessLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BrandLogo() {
    let prop = Other.Props.BrandLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function Email() {
    let prop = Other.Props.Email;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorIcon() {
    let prop = Other.Props.StoreSelectorIcon;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorOption(storeName) {
    let prop = Other.Props.StoreSelectorOption;
    sendUserAction(Other.EventCategory, prop.EventAction, storeName);
}

export function ShareButtonClicked() {
    let prop = Other.Props.ShareButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ChatIconClicked(currentScene) {
    let prop = Other.Props.ChatIconClicked;
    let eventAction = `${prop.EventAction} ${currentScene}`;
    let eventLabel = `${prop.EventLabel} ${currentScene}`;
    sendUserAction(Other.EventCategory, eventAction, eventLabel);
}

export function ShareOptionClicked(eventAction, eventLabel) {
    sendUserAction(Other.EventCategory, eventAction, eventLabel);
}

export function MailIconClicked() {
    let prop = Other.Props.MailIconClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function InstagramClicked() {
    let prop = Other.Props.InstagramClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TextPopUpHotSpotClicked(textName) {
    let prop = Content.Props.TextPopUpHotSpotClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${textName}`);
}

export function TextPopUpButtonClicked(textName) {
    let prop = Content.Props.TextPopUpButtonClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${textName}`);
}

export function ImageCarouselClicked(popupTitle, currentScene) {
    let prop = Content.Props.ImageCarouselClicked;
    let eventAction = `${prop.EventAction} ${popupTitle} ${currentScene}`;
    let eventLabel = `${prop.EventLabel} ${popupTitle} ${currentScene}`;
    sendUserAction(Content.EventCategory, eventAction, eventLabel);
}

export function MapSectionClicked(sceneName) {
    let prop = Other.Props.MapSectionClicked;
    let eventAction = `${prop.EventAction}`;
    let eventLabel = `${prop.EventLabel}${sceneName}`;
    sendUserAction(Other.EventCategory, eventAction, eventLabel);
}

export function BookAppointmentClicked(title, sceneName) {
    let prop = Content.Props.BookAppointmentClicked;
    let eventAction = `${prop.EventAction}`;
    let eventLabel = `${prop.EventLabel}${title} - ${sceneName}`;
    sendUserAction(Content.EventCategory, eventAction, eventLabel);
}
export function WishlistBookAppointmentClicked(sceneName = '') {
    let prop = Other.Props.WishlistBookAppointmentClicked;
    let eventAction = `${prop.EventAction}`;
    let eventLabel = `${prop.EventLabel}${sceneName}`;
    sendUserAction(Content.EventCategory, eventAction, eventLabel);
}

export function WelcomePopupXButtonClicked() {
    let prop = Other.Props.WelcomePopupXButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WelcomeCloseAwayClicked() {
    let prop = Other.Props.WelcomeCloseAwayClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WelcomeAutoCloseClicked() {
    let prop = Other.Props.WelcomeAutoCloseClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function PoweredByClicked() {
    let prop = Other.Props.PoweredByClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

// Media
export function InSceneVideoClicked(name) {
    let prop = Content.Props.InSceneVideoClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function PopupVideoClicked(name) {
    let prop = Content.Props.PopupVideoClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function ImageClicked(name) {
    let prop = Content.Props.ImageClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function TextClicked(title) {
    let prop = Content.Props.TextClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, title);
}

export function LinkClicked(targetUrl) {
    let prop = Content.Props.LinkClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, targetUrl);
}


// Wishlist
export function SMSButtonClicked() {
    let prop = Wishlist.Props.SMSButtonClicked;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}
export function LocalStoreIconClicked(link) {
    let prop = Wishlist.Props.LocalStoreIconClicked;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, link);
}

export function NameAddedInOrderForm() {
    let prop = Wishlist.Props.NameAddedInOrderForm;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}

export function EmailAddedInOrderForm() {
    let prop = Wishlist.Props.EmailAddedInOrderForm;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}

export function PhoneNumberAddedInOrderForm() {
    let prop = Wishlist.Props.PhoneNumberAddedInOrderForm;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}

export function SubmitOrderClicked() {
    let prop = Wishlist.Props.SubmitOrderClicked;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}

export function CloseOrderFormClicked() {
    let prop = Wishlist.Props.CloseOrderFormClicked;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}
export function CallToOrderClicked() {
    let prop = Wishlist.Props.CallToOrderClicked;
    sendUserAction(Wishlist.EventCategory, prop.EventAction, prop.EventLabel);
}
// Page
export function VirtualPageVisited(pageUri) {
    if (!window.gtag) {
        console.log('no gtag');
        const path = storeName + '/' + pageUri;
        missedVirtualPagePaths.push(path);
        return;
    }
    getGAIdAsync()
        .then(id => {
            console.log('virtual page visited', pageUri);
            console.log('sending ga to', id);
            // window.gtag('config', id, { 'page_path': '/main/' + pageUri });
            window.gtag('config', id, { 'page_path': storeName + '/' + pageUri });
        })
        .catch(error => console.error(error));
}
